import { useEffect, useState } from "react";
import { ctaClickEvent, pageViewEvent } from "../services/adobeDataLayer";
import { DataLayerEvent, getValuesInLocalStorange } from "../services/lsq";

function ThankYou() {
  const [executed, setExecuted] = useState(false);
  useEffect(() => {
    //Trigger ADL on Thank you page load
    pageViewEvent("thank you");

    // Gtag Event snippet for icicibank-a2-homeloan-landingpage-submit conversion page
    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-822902461/BT_-CJ2D8uwBEL39sYgD",
      });
    }

    if (!executed) {
      let pushToDataLayer = async () => {
        const resp = await getValuesInLocalStorange("userData");
        DataLayerEvent(resp?.email, resp?.mobile, "", "", "", "", false);
      };
      pushToDataLayer();
      setExecuted(true);
    }
  }, []);

  return (
    <>
      <article className="thankyou_sec">
        <div className="tick">
          <img
            src="../dist/img/call.png"
            alt="tick"
            width="100"
            height="100"
            className="img-fluid"
          />
        </div>
        <div className="thankyou_txt">
          <p style={{ width: "60%", marginLeft: "auto", marginRight: "auto" }}>
            Thank you for your interest in ICICI Bank Home Loan. Our
            representative will get in touch with you from a number starting
            with 1600-XX-XXXX
          </p>
          <p
            className="secondary_txt"
            style={{ width: "60%", marginLeft: "auto", marginRight: "auto" }}
          >
            In case you need assistance in selecting your dream home, please{" "}
            <a
              href="http://home.icicibank.com?utm_source=APFWebsite&utm_medium=SocialMedia&utm_campaign=PAHL_BAU"
              onClick={() => {
                ctaClickEvent(
                  "click here",
                  "thank you page",
                  "text link",
                  0,
                  "http://home.icicibank.com?utm_source=APFWebsite&utm_medium=SocialMedia&utm_campaign=PAHL_BAU",
                );
              }}
            >
              {" "}
              click here
            </a>{" "}
            and explore the vast list of builder projects approved for home
            loan.
          </p>
        </div>
      </article>
    </>
  );
}

export default ThankYou;
